import { useAuth } from '@clerk/react'
import { useMemo } from 'react'
import { type ApiClient, createApiClient } from './api-client'

export function useApi(): ApiClient {
  const { getToken } = useAuth()
  return useMemo(() => createApiClient({ getToken: () => getToken() }), [getToken])
}
